import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=loading, false=guest, object=logged in
  const [loading, setLoading] = useState(true);

  // On mount, check URL hash for `#auth=<jwt>` (magic-link recovery flow).
  // If present, store the token and clean the URL before fetching /auth/me.
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash || "";
    const match = hash.match(/auth=([^&]+)/);
    if (match) {
      try {
        const token = decodeURIComponent(match[1]);
        if (token) localStorage.setItem("sakura_admin_token", token);
      } catch (_) {}
      // Clean the hash so the token isn't visible in the URL bar.
      try {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      } catch (_) {}
    }
  }, []);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch (_) {
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.access_token) {
      localStorage.setItem("sakura_admin_token", data.access_token);
    }
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("sakura_admin_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
